import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import TextualMenu from '../../../../Dropdown/Preset/TextualMenu';
import { MobileContext } from '../../../../Context/MobileContext';
import { BiSpan, BiEventType } from '../../../../biLogger';
var MoreMenuContent = function (_a) {
    var deviation = _a.deviation, _b = _a.closeTooltip, closeTooltip = _b === void 0 ? function () { return null; } : _b, showGroupsPanel = _a.showGroupsPanel, showReportModal = _a.showReportModal;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    return (React.createElement(TextualMenu, { onClose: closeTooltip, items: [
            isMobile && {
                value: 'addToGroup',
                label: t('actionbar.addToGroup'),
                onClick: function () {
                    showGroupsPanel(deviation);
                    closeTooltip();
                },
            },
            {
                value: 'report',
                label: t('actionbar.report'),
                componentClass: BiSpan,
                componentProps: {
                    biData: {
                        evid: BiEventType.CLICK_REPORT_BUTTON,
                        modal_version: 2,
                    },
                },
                onClick: function () {
                    showReportModal(deviation);
                    closeTooltip();
                },
            },
        ] }));
};
MoreMenuContent.displayName = 'MoreMenuContent';
export default MoreMenuContent;
//# sourceMappingURL=MoreMenuContent.js.map